import { Box, Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useBrandIngredientsUpload } from "../hooks";

export const BrandIngredients = () => {
  const [errorMessage, setError] = useState(null);
  const [statusMessage, setStatusMessage] = useState(null);
  const {
    mutateAsync: uploadBrandIngredients,
    isLoading,
    isError,
    error
  } = useBrandIngredientsUpload();

  const onCVSUpload = async (e) => {
    e.preventDefault();
    setError(null);
    const file = e.target.elements[0].files[0];
    const formData = await file.text();
    try {
      const resp = await uploadBrandIngredients({ brandIngredientsCSV: formData });
      setStatusMessage(`Success: ${resp.message}`);
    } catch (error) {
      if (error.response) {
        setError(`Error: ${error.response.data.error}`);
      } else {
        setError(`Error: ${error.message}`);
      }
    }
  };

  useEffect(() => {
    if (isError) {
      setError(`Error: ${error.message}`);
    }
  }, [isError, error]);

  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ pt: 4, mx: 4, flex: 1 }}>
        <h3>Brand Ingredients Uploader</h3>
        <p>
          This page is for uploading CSV files of brand ingredients. The CSV file
          must have a header row with the following columns:
        </p>
        <ul>
          <li>
            <strong>brand_id</strong> - integer (use this OR brand_name, not both)
          </li>
          <li>
            <strong>brand_name</strong> - text (use this OR brand_id, not both)
          </li>
          <li>
            <strong>ingredient_name</strong> - text (required)
          </li>
          <li>
            <strong>product_name</strong> - text (optional)
          </li>
        </ul>
        <p>
          <strong>Note:</strong> You must provide either brand_id or brand_name to identify the brand.
          If using brand_name, it must match exactly with an existing brand name.
        </p>
        <p>
          <strong>Duplicate handling:</strong> The upload is idempotent - it will skip ingredients that already exist.
          An ingredient is considered duplicate if it has the same brand and ingredient name.
          If a product name is specified, it must also match for the record to be considered a duplicate.
        </p>
        {isLoading && <p>Uploading...</p>}
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        {statusMessage && <p style={{ color: "green" }}>{statusMessage}</p>}
        <form onSubmit={onCVSUpload}>
          <TextField type="file" inputProps={{ accept: ".csv" }} />
          <Button type="submit">Upload</Button>
        </form>
      </Box>
    </Box>
  );
};
